import { Box } from '@mui/material'
import { InfoDisplay } from '../../../utility/Containers'
import { FilteredTreeTable } from '../FilteredTreeTable'
import { allSkillLeaves } from '../filters'
import React from 'react'

export function AllSkillLeaves({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  return (
    <Box>
      <InfoDisplay>
        <Box>All Skill Leaves</Box>
        <Box>
          Deleting all skill leaves can not be undone, once this process is
          started we will have lost skill leaves that can not be recovered. This
          process will take some time so leave the browser window open until it
          is done, but you can always restart if interrupted.
        </Box>
      </InfoDisplay>
      <FilteredTreeTable
        filter={allSkillLeaves}
        treeId={treeId}
        versionId={versionId}
        action={{ actionType: 'delete' }}
      />
    </Box>
  )
}
